import { render, staticRenderFns } from "./TwoFactorAuthentication.vue?vue&type=template&id=53bf6d0f&scoped=true&"
import script from "./TwoFactorAuthentication.vue?vue&type=script&lang=ts&"
export * from "./TwoFactorAuthentication.vue?vue&type=script&lang=ts&"
import style0 from "./TwoFactorAuthentication.vue?vue&type=style&index=0&id=53bf6d0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bf6d0f",
  null
  
)

export default component.exports